module.exports = __webpack_public_path__ + "img/notice.37af2193.png";